// Constants
import { LANDSCAPE_HEIGHT_DELTA } from '../constants/ui';

const values = {
  xs: 0,
  sm: 420,
  md: 768,
  lg: 1024,
  xl: 1280,
};
export default {
  values,
  downLandscape: (heightKey) => {
    const deltaViewportScreen =
      +localStorage.getItem('deltaViewportScreen') || 0;

    return `@media (max-height: ${
      values[heightKey] - deltaViewportScreen - LANDSCAPE_HEIGHT_DELTA
    }px) and (orientation: landscape)`;
  },
};
